/**
 * Orbit Phase 7 — pure helpers for Hub / Overlay flow-chain Orbit tab status + CTAs.
 */

import {
  isOrbitRunningStatus,
  orbitResultLines,
  type OrbitJobStatus,
} from "@/features/footwear-studio/orbit/orbitUi";

export type FlowOrbitJob = {
  id: string;
  status: OrbitJobStatus | string;
  result?: unknown;
};

export type FlowOrbitMode = "none" | "running" | "done" | "error";

export function flowOrbitMode(
  job: FlowOrbitJob | null | undefined,
): FlowOrbitMode {
  if (!job) return "none";
  if (isOrbitRunningStatus(job.status)) return "running";
  if (job.status === "done") return "done";
  if (job.status === "error") return "error";
  return "none";
}

/** Hero / node status line under the master image (H-3). */
export function flowOrbitStatusLine(
  job: FlowOrbitJob | null | undefined,
): string {
  const mode = flowOrbitMode(job);
  if (mode === "running") return "Orbit in progress";
  if (mode === "error") return "Orbit couldn't be completed";
  if (mode === "none") return "No Orbit yet — open the style to create one";
  const lines = orbitResultLines(job?.result);
  const bits: string[] = ["Orbit ready"];
  if (lines.missingLine) bits.push(lines.missingLine);
  if (lines.cutOffLine) bits.push(lines.cutOffLine);
  if (lines.pathCheckLine) bits.push(lines.pathCheckLine);
  if (lines.topTurnedLine) bits.push(lines.topTurnedLine);
  if (lines.identityLine) bits.push(lines.identityLine);
  if (bits.length === 1) return "Orbit ready";
  return bits.join(" · ");
}

export function flowOrbitOpenLabel(mode: FlowOrbitMode): string {
  return mode === "done" ? "Open Orbit" : "Open Showcase";
}

export function flowOrbitOpenContext(mode: FlowOrbitMode): {
  openOrbitViewer?: boolean;
} {
  return mode === "done" ? { openOrbitViewer: true } : {};
}
